import { render, staticRenderFns } from "./TablePayoutOther.vue?vue&type=template&id=fb54948c"
import script from "./TablePayoutOther.vue?vue&type=script&lang=js"
export * from "./TablePayoutOther.vue?vue&type=script&lang=js"
import style0 from "./TablePayoutOther.vue?vue&type=style&index=0&id=fb54948c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports